import React from 'react';
import {
    Badge,
    Stack,
    Button,
    InlineError
} from '@shopify/polaris';
import {
    DeleteMajor
} from '@shopify/polaris-icons';

function ProductConditionItem(props) {

    const hasError = !(props.error === "" || props.error == null);
    let className = "genieConditionItem";

    if (hasError) {
        className += " error";
    }

    return (
        <div className={className}>
            <Stack alignment="center" spacing="tight">
                <Stack.Item>
                    <Badge>{props.number}</Badge>
                </Stack.Item>
                <Stack.Item fill>
                    {props.children}
                </Stack.Item>
                <Stack.Item>
                    <Button outline icon={DeleteMajor} onClick={props.onDelete}></Button>
                </Stack.Item>
            </Stack>
            {hasError && <div>
                <InlineError message={props.error} />
            </div>
            }
        </div>
    );
}

ProductConditionItem.defaultProps = {
    onDelete: () => { },
    number: 0
}

export default ProductConditionItem;